export class RestrictionsApplier {
    /**
     * @param {{ plan: string, status: string }} billing Workspace billing model description
     * @param {boolean} lenient Should be graceful period for failed payment be taken into account
     * @returns {boolean} <code>true</code> if this restrictor is applicable
     */
    // eslint-disable-next-line no-unused-vars
    applicable(billing, lenient) {
        return true;
    }

    /**
     * @param {*} target Which object to process
     * @returns {boolean} <code>true</code> if any restriction was applied, false otherwise
     */
    // eslint-disable-next-line no-unused-vars
    apply(target) {
        return false;
    }
}
